// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vavaka {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  margin-top: 15%;
  margin-left: 15%;
  margin-right: 15%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Vavaka/ShowVavaka/showvavaka.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACF","sourcesContent":[".vavaka{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  background: #fff;\n  padding: 20px;\n  border-radius: 10px;\n  margin-top: 15%;\n  margin-left: 15%;\n  margin-right: 15%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
